// import logoLacoste from 'assets/img/logos/Lacoste.png';
// import logoEcoalf from 'assets/img/logos/Ecoalf.png';
// import logoHub4Retail from 'assets/img/logo192.png';

import { InitialNotificationsState } from 'interfaces/notifications.interface';

const initialNotificationsState: InitialNotificationsState = {
  // notifications: [
  // 	{
  // 		id: "1",
  // 		summary: "¡Bienvenido a Hub4Retail! Comienza tu colaboración con tus clientes",
  // 		message: "¡Bienvenido a Hub4Retail! Comienza tu colaboración con tus clientes",
  // 		icon: logoHub4Retail,
  // 		read: false,
  // 		createdAt: '2023-10-31T13:32:39.825Z',
  // 		updatedAt: '2023-10-31T13:32:39.825Z'
  // 	},
  // 	{
  // 		id: "2",
  // 		summary: "<Wholesale> ha solicitado trabajar contigo",
  // 		message: "<Wholesale> ha solicitado trabajar contigo. ¡Comienza la colaboración!",
  // 		icon: logoLacoste,
  // 		read: false,
  // 		complete: 'url',
  // 		abort: 'url',
  // 		details: {
  // 			type: 'profile-wholesale',
  // 			id: "profile_id"
  // 		},
  // 		createdAt: '2023-10-30T12:32:39.825Z',
  // 		updatedAt: '2023-10-30T12:32:39.825Z'
  // 	},
  // 	{
  // 		id: "3",
  // 		summary: "<Wholesale> ha dejado de trabajar contigo",
  // 		message: "<Wholesale> ha dejado de trabajar contigo.",
  // 		icon: logoLacoste,
  // 		read: false,
  // 		createdAt: '2023-10-31T12:32:39.825Z',
  // 		updatedAt: '2023-10-31T12:32:39.825Z'
  // 	},
  // ],
  // alerts: [
  // 	{
  // 		id: '1',
  // 		summary: "<punto de venta> lleva 48 horas sin recibir datos",
  // 		message: "<punto de venta> lleva 48 horas sin recibir datos",
  // 		read: false,
  // 		icon: logoEcoalf,
  // 		createdAt: '2023-10-31T12:32:39.825Z',
  // 		updatedAt: '2023-10-31T12:32:39.825Z'
  // 	}
  // ],
  notifications: [],
  notificationsTypes: [],
  getNotificationsTypes: () => Promise.resolve(false),
  markAsReaded: () => {},
};

export default initialNotificationsState;
